module.exports = __webpack_public_path__ + "static/img/wisdomPlanRight.3fdaa68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wisdomPlanRight.png
// module id = RB0Q
// module chunks = 2